import React, { useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import {
    TextField,
    Button,
    Box,
    Typography,
    CircularProgress,
    Alert,
} from '@mui/material';
import { getPasswordErrors } from '../../shared/utils.js';


const ResetPasswordForm = () => {
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');

    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const token = searchParams.get('token');
    console.log('token ' + token);
    const passwordErrors = getPasswordErrors(newPassword);
    const passwordHasError = newPassword.length > 0 && passwordErrors.length > 0;
    const passwordsMatch = newPassword === confirmPassword;

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setMessage('');
        setError('');


        try {
            const baseUrl = process.env.REACT_APP_HOST && process.env.REACT_APP_PORT
            ? `${process.env.REACT_APP_HOST}:${process.env.REACT_APP_PORT}/api/`
              : 'http://localhost:3000/api/';

            const response = await fetch(`${baseUrl}account/reset-password`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ token, newPassword, confirmPassword }),
            });

            const data = await response.json();

            if (response.ok) {
                setMessage(data.message);
                setTimeout(() => {
                    navigate('/login'); // Redireciona para o login após 3 segundos
                }, 3000);
            } else {
                setError(data.message || 'Erro ao redefinir a senha.');
            }
        } catch (err) {
            setError('Erro de conexão. Por favor, tente novamente mais tarde.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
                width: '100%',
                maxWidth: 400,
                mx: 'auto',
                p: 3,
                border: '1px solid #ccc',
                borderRadius: 2,
                mt: 5,
            }}
        >
            <Typography variant="h5" align="center">
                Redefinir Senha
            </Typography>

            <TextField
                fullWidth
                label="Nova Senha"
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
                error={passwordHasError}
                helperText={passwordHasError ? `Falta: ${passwordErrors.join(', ')}` : ''}
            />

            <TextField
                fullWidth
                label="Confirme a Nova Senha"
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                error={confirmPassword.length > 0 && !passwordsMatch}
                helperText={confirmPassword.length > 0 && !passwordsMatch ? 'As senhas não coincidem.' : ''}
            />

            {isLoading && <CircularProgress size={24} sx={{ alignSelf: 'center' }} />}
            {message && <Alert severity="success">{message}</Alert>}
            {error && <Alert severity="error">{error}</Alert>}

            <Button
                fullWidth
                variant="contained"
                type="submit"
                size="large"
                disabled={isLoading || !newPassword || !confirmPassword || passwordErrors.length > 0 || !passwordsMatch}
            >
                Redefinir Senha
            </Button>

            <Typography variant="body2" align="center">
                Lembrou da senha?{' '}
                <Link to="/login" style={{ textDecoration: 'none' }}>
                    Faça login
                </Link>
            </Typography>
        </Box>
    );
};

export default ResetPasswordForm;